import { Outlet, useLocation } from "react-router";
import { Fragment, useMemo } from "react";

import NavbarSidebarLayout from "./navbar-sidebar";

export interface NavbarSidebarWrapperProps {
  noFooterRoutes?: string[];
  noWrapperRoutes?: string[];
}

export function NavbarSidebarWrapper({
  noFooterRoutes,
  noWrapperRoutes,
}: NavbarSidebarWrapperProps) {
  const { pathname } = useLocation();

  const { isFooter, isWrapped } = useMemo(() => {
    const trimmedPathname = pathname.replace(/^\/|\/$/g, "");

    return {
      isFooter: !noFooterRoutes?.includes(trimmedPathname),
      isWrapped: !noWrapperRoutes?.includes(trimmedPathname),
    };
  }, [noWrapperRoutes, noFooterRoutes]);

  return isWrapped ? (
    <NavbarSidebarLayout isFooter={isFooter} children={<Outlet />} />
  ) : (
    <Fragment children={<Outlet />} />
  );
}
